import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUser } from '../../auth/AuthPage/UserContext';
import Icon from '../../common/Icon/Icon';
import './Contact.css';

const TOPICS = ['General', 'Bug report', 'Middleman application', 'Trade dispute', 'Legal'];

function Contact() {
    const { user } = useUser();
    const [params] = useSearchParams();
    const topicParam = params.get('topic');

    const [name, setName] = useState(user?.username || '');
    const [email, setEmail] = useState(user?.email || '');
    const [topic, setTopic] = useState(
        topicParam === 'middleman' ? 'Middleman application'
            : topicParam === 'bug' ? 'Bug report' : 'General'
    );
    const [message, setMessage] = useState('');
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            const res = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, email, subject: topic, message }),
            });
            const d = await res.json();
            if (!res.ok) throw new Error(d.error || 'Could not send your message.');
            setDone(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="contact-page">
            <header className="page-section-head">
                <h1>Contact</h1>
            </header>

            <div className="contact-card">
                {done ? (
                    <div className="contact-done">
                        <div className="contact-done-emoji"><Icon name="send" size={44} /></div>
                        <h2>Message sent</h2>
                        <p>Thanks! We read everything and reply to {email}.</p>
                    </div>
                ) : (
                    <form className="contact-form" onSubmit={submit}>
                        <p className="contact-intro">
                            Questions, bug reports, middleman applications: this lands directly
                            with the team.
                        </p>
                        <div className="contact-row">
                            <label>
                                Name
                                <input value={name} maxLength={80} onChange={e => setName(e.target.value)} placeholder="Optional" />
                            </label>
                            <label>
                                Email
                                <input type="email" required value={email} maxLength={255} onChange={e => setEmail(e.target.value)} placeholder="So we can reply" />
                            </label>
                        </div>
                        <label>
                            Topic
                            <select value={topic} onChange={e => setTopic(e.target.value)}>
                                {TOPICS.map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </label>
                        {topic === 'Middleman application' && (
                            <p className="contact-hint">
                                Tell us about your shop: name, location, hours, and your experience
                                handling card trades. We'll get back to you about verification.
                            </p>
                        )}
                        <label>
                            Message
                            <textarea
                                required
                                rows={7}
                                maxLength={4000}
                                value={message}
                                onChange={e => setMessage(e.target.value)}
                                placeholder="What's on your mind?"
                            />
                        </label>
                        <button className="cta-gold contact-send" type="submit" disabled={busy}>
                            {busy ? 'Sending…' : 'Send message'}
                        </button>
                        {error && <p className="contact-error">{error}</p>}
                    </form>
                )}
            </div>
        </div>
    );
}

export default Contact;
